module.exports = __webpack_public_path__ + "assets/img/6-3.eb35a1b4.png";